module.exports = __webpack_public_path__ + "img/radio-johor.38314123.jpg";